import { get, del, post, put } from '@api/request';
import $ from 'jquery';

export const fetchTotalsInProgress = async (
  { reportService },
  authenticationToken,
) => {
  const url = `${reportService}/appraisal/totals/inprogresscheck`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteReport = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/report/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchSearchConfig = async (
  { reportService },
  authenticationToken,
) => {
  const url = `${reportService}/reporting/config/reportsearch`;
  let { body } = await get(authenticationToken, url);
  const results = {
    results: [
      {
        multi: true,
        options: [
          { value: 'appraisal', label: 'Appraisal', operator: '=' },
          { value: 'ci', label: 'CI', operator: '=' },
          { value: 'collections', label: 'Collections', operator: '=' },
          { value: 'equifinder', label: 'Equifinder', operator: '=' },
          { value: 'events', label: 'Events', operator: '=' },
          { value: 'mra', label: 'MRA', operator: '=' },
        ],
        // options: ['appraisal', 'ci'],
        description: 'Module',
        group: 1,
        grouping: 'Basic Search',
        id: 'module',
        operators: ['='],
        order: 1,
        type: 'string',
      },
      {
        description: 'Report Name',
        group: 1,
        grouping: 'Basic Search',
        id: 'reportName',
        operators: ['like'],
        order: 2,
        type: 'string',
      },
      {
        description: 'Group Name',
        group: 1,
        grouping: 'Basic Search',
        id: 'groupName',
        operators: ['like'],
        order: 3,
        type: 'string',
      },
      // {
      //   codefile: {
      //     byYear: false,
      //     codeFileName: 'Property Type',
      //     codeFileType: 'Property'
      //   },
      //   description: 'Module',
      //   group: 1,
      //   grouping: 'Basic Search',
      //   id: 'module',
      //   operators: ['in'],
      //   order: 2,
      //   type: 'string',
      // },
      {
        description: 'Tags',
        group: 1,
        grouping: 'Basic Search',
        id: 'tags',
        operators: ['in'],
        order: 4,
        type: 'tags',
      },
      {
        description: 'Certified Mailer Enabled',
        group: 1,
        grouping: 'Basic Search',
        id: 'certifiedMailerEnabled',
        operators: ['='],
        order: 5,
        type: 'bit',
      },
      {
        description: 'Create Date',
        group: 1,
        grouping: 'Basic Search',
        id: 'createDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 6,
        type: 'date',
      },
      {
        description: 'Created By',
        group: 1,
        grouping: 'Basic Search',
        id: 'createdBy',
        operators: ['like'],
        order: 7,
        type: 'string',
      },
      {
        description: 'Update Date',
        group: 1,
        grouping: 'Basic Search',
        id: 'updateDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 8,
        type: 'date',
      },
      {
        description: 'Updated By',
        group: 1,
        grouping: 'Basic Search',
        id: 'updatedBy',
        operators: ['like'],
        order: 9,
        type: 'string',
      },
    ],
  };
  body = results;
  return body;
};

export const fetchSearchResultsConfig = async (
  { sketchService },
  authenticationToken,
) => {
  const url = `${sketchService}/sketchservice/config/sketchsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateReportDefinition = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/report/${payload.reportID}`;
  const { body } = await put(authenticationToken, url, payload.body);
  return body;
};

export const fetchMassCreate = async (
  { eventService },
  authenticationToken,
  { payload },
) => {
  const url = `${eventService}/events/masscreate/${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getOwnerTags = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Owner&name=Tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getReportJobs = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/jasperserver-pro/rest_v2/jobs`;
  let { body } = await get(authenticationToken, url);
  if (body === undefined) {
    body = { jobsummary: [] };
  }
  let temp = [];
  for (let x = 0; x < body.jobsummary.length; x++) {
    if (body.jobsummary[x].reportLabel === payload.reportFileName) {
      temp.push(body.jobsummary[x]);
    }
  }
  body.jobsummary = temp;
  return body;
};

export const processAdjustedTotals = async (
  { appraisalService },
  authenticationToken,
  { rollGroupID },
) => {
  const url = `${appraisalService}/appraisal/rollcorrectiongroup/${rollGroupID}/adjusttotals`;
  const { body } = await post(authenticationToken, url, {});
  return body;
};

export const processReportJob = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  let newBody = {
    id: 15713,
    version: 1,
    username: payload.user
      ? `${payload.user.office.replace(/\s+/g, '').toLowerCase()}${
          payload.env === 'prod' ? 'prod' : ''
        }`
      : 'superuser2',
    label: `${payload.reportFileName} job`,
    description: `${payload.reportFileName} job`,
    creationDate: '2019-11-16T17:20:16.847Z',
    trigger: {
      simpleTrigger: {
        id: 15711,
        version: 0,
        timezone: 'Universal',
        startType: 2,
        startDate: '2019-12-12 00:00',
        misfireInstruction: 0,
        occurrenceCount: 1,
      },
    },
    baseOutputFilename: payload.uniqueFileName
      ? payload.uniqueFileName
      : payload.reportFileName,
    outputLocale: 'en_US',
    outputTimeZone: 'America/Chicago',
    source: {
      reportUnitURI: `${payload.reportLocation}${payload.reportFileName}`,
      parameters: {
        parameterValues: payload.params,
      },
    },
    outputFormats: {
      outputFormat: [payload.reportFormat],
    },
    repositoryDestination: {
      folderURI:
        payload.reportLocation.length > 0
          ? payload.reportLocation.substring(
              0,
              payload.reportLocation.length - 1,
            )
          : 'public/Samples/Reports',
      id: 15712,
      overwriteFiles: true,
      sequentialFilenames: false,
      version: 0,
      saveToRepository: false,
      usingDefaultReportOutputFolderURI: false,
      outputFTPInfo: {
        userName: 'anonymous',
        type: 'ftp',
        port: 21,
        implicit: true,
        pbsz: 0,
      },
    },
    mailNotification: {
      bccAddresses: {
        address: [],
      },
      ccAddresses: {
        address: [],
      },
      toAddresses: {
        address: payload.emailList,
      },
      version: 0,
      id: 33451,
      includingStackTraceWhenJobFails: false,
      messageText: `${
        payload.destinationMessage
          ? payload.destinationMessage
          : 'Report attached.'
      }`,
      resultSendType: 'SEND_ATTACHMENT',
      skipEmptyReports: false,
      skipNotificationWhenJobFails: false,
      subject: payload.emailSubject
        ? payload.emailSubject
        : `Report: ${payload.reportName}`,
    },
    alert: {
      id: 0,
      version: -1,
      recipient: 'OWNER_AND_ADMIN',
      jobState: 'ALL',
      messageText: 'Report job successfully executed.',
      messageTextWhenJobFails:
        'The report job was not able to successfully execute.',
      subject: `Report Notification: ${payload.reportName}`,
      includingStackTrace: true,
      includingReportJobInfo: true,
      toAddresses: {
        address: payload.notificationEmailList
          ? payload.notificationEmailList
          : [],
      },
    },
  };
  newBody.trigger = payload.trigger;
  const url = `${reportService}/reporting/jasperserver-pro/rest_v2/jobs`;
  let { body } = await get(authenticationToken, url);
  if (body === undefined) {
    body = { jobsummary: [] };
  }
  let temp = [];
  for (let x = 0; x < body.jobsummary.length; x++) {
    if (
      body.jobsummary[x].reportLabel === payload.reportFileName &&
      body.jobsummary[x].reportUnitURI ===
        `${payload.reportLocation}${payload.reportFileName}`
    ) {
      temp.push(body.jobsummary[x]);
    }
  }
  body.jobsummary = temp;
  if (body.jobsummary.length === 0 || payload.unique) {
    await $.ajax({
      type: 'PUT',
      url: `${reportService}/reporting/jasperserver-pro/rest_v2/jobs`,
      data: JSON.stringify(newBody),
      dataType: 'json',
      beforeSend: function (request) {
        // request.setRequestHeader("Authorization", "Basic " + btoa(jasperUser + ":" + jasperPass));
        request.setRequestHeader('Content-Type', 'application/job+json');
        // request.setRequestHeader("Accept", "application/job+json");
        request.setRequestHeader('X-REMOTE-DOMAIN', 1);
      },
      success: function (data) {
        console.log('job successfully created');
        body.data = data;
        return body;
      },
      error: function (xhr, textStatus) {
        alert(textStatus);
      },
    });
    return body;
  } else {
    newBody.version = body.jobsummary[0].version;
    await $.ajax({
      type: 'POST',
      url: `${reportService}/reporting/jasperserver-pro/rest_v2/jobs/${body.jobsummary[0].id}`,
      data: JSON.stringify(newBody),
      dataType: 'json',
      beforeSend: function (request) {
        // request.setRequestHeader("Authorization", "Basic " + btoa(jasperUser + ":" + jasperPass));
        request.setRequestHeader('Content-Type', 'application/json');
        // request.setRequestHeader("Accept", "application/json");
        request.setRequestHeader('X-REMOTE-DOMAIN', 1);
      },
      success: function (data) {
        console.log('job successfully edited');
        body.data = data;
        return body;
      },
      error: function (xhr, textStatus) {
        alert(textStatus);
      },
    });
    return body;
  }
};

export const createReportDefinition = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/reports`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchReportDefinitions = async (
  { reportService },
  authenticationToken,
  // eslint-disable-next-line no-unused-vars
  { payload },
) => {
  const url = `${reportService}/reporting/reports`;
  const { body } = await get(authenticationToken, url);
  return body;
};

// HERE CURRENT Try to hijack this for letter generation
export const createReportEvents = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const newBody = {
    id: 15713,
    version: 1,
    username: 'superuser2',
    label: `${payload.reportFileName} job`,
    description: `${payload.reportFileName} job`,
    creationDate: '2019-11-16T17:20:16.847Z',
    trigger: {
      simpleTrigger: {
        startType: 1,
        misfireInstruction: null,
        occurrenceCount: 1,
      },
    },
    baseOutputFilename: payload.reportFileName,
    outputLocale: 'en_US',
    outputTimeZone: 'Universal',
    source: {
      reportUnitURI: `${payload.reportLocation}${payload.reportFileName}`,
      parameters: {
        parameterValues: payload.params,
      },
    },
    outputFormats: {
      outputFormat: [payload.reportFormat],
    },
    repositoryDestination: {
      folderURI:
        payload.reportLocation.length > 0
          ? payload.reportLocation.substring(
              0,
              payload.reportLocation.length - 1,
            )
          : 'public/Samples/Reports',
      id: 15712,
      overwriteFiles: true,
      sequentialFilenames: false,
      version: 0,
      saveToRepository: false,
      usingDefaultReportOutputFolderURI: false,
      outputFTPInfo: {
        userName: 'anonymous',
        type: 'ftp',
        port: 21,
        implicit: true,
        pbsz: 0,
      },
    },
    mailNotification: {
      bccAddresses: {
        address: [],
      },
      ccAddresses: {
        address: [],
      },
      toAddresses: {
        address: payload.emailList,
      },
      version: 0,
      id: 33451,
      includingStackTraceWhenJobFails: false,
      messageText: `${
        payload.destinationMessage
          ? payload.destinationMessage
          : 'Report attached.'
      }`,
      resultSendType: 'SEND_ATTACHMENT',
      skipEmptyReports: false,
      skipNotificationWhenJobFails: false,
      subject: `Report: ${payload.reportName}`,
    },
    alert: {
      id: 0,
      version: -1,
      recipient: 'OWNER_AND_ADMIN',
      jobState: 'ALL',
      messageText: 'Report job successfully executed.',
      messageTextWhenJobFails:
        'The report job was not able to successfully execute.',
      subject: `Report Notification: ${payload.reportName}`,
      includingStackTrace: true,
      includingReportJobInfo: true,
      toAddresses: {
        address: payload.notificationEmailList
          ? payload.notificationEmailList
          : [],
      },
    },
  };
  const url = `${reportService}/reporting/reportevents`;
  const { body } = await post(authenticationToken, url, newBody);
  return body;
};

export const createReportEventsV2 = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/createreportevents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const createReportSubmission = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/report/${payload.reportID}/submissions`;
  const { body } = await post(authenticationToken, url, payload.body);
  return body;
};

export const finalizeReportSubmission = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/reportSubmission/${payload.reportSubmissionID}/finalize`;
  const { body } = await put(authenticationToken, url, payload.body);
  return body;
};

export const fetchReportSubmissions = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/report/${payload.reportID}/submissions`;
  const { body } = await get(authenticationToken, url);
  console.log(body);
  return body;
};

export const search = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  if (payload.tags) {
    payload.tags.operator = 'in';
    payload.tags.values = [payload.tags.value];
  }
  const url = `${reportService}/reporting/reportsearch`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchReport = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/report/${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const postComment = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload.ciID}/comments`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getComments = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}/comments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getReportInfo = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/jasperserver-pro/rest_v2/${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteComment = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getTaxingUnits = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/property/taxingunitlookup?address=${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getAppraisalCiInitialData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/property/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getAppraisalSearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const data1 = await getPropertyData(
    { appraisalService },
    authenticationToken,
    {
      payload,
    },
  );
  return data1;
};

export const getCiApiSettings = async (
  { gamaService },
  authenticationToken,
) => {
  const url = `${gamaService}/gama/cisettings`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const setCiApiSettings = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/cisettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getGisApiSettings = async (
  { gamaService },
  authenticationToken,
) => {
  const url = `${gamaService}/gama/gissettings`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const setGisApiSettings = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/gissettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getPropertySearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  let data1 = await getPropertyData({ appraisalService }, authenticationToken, {
    payload,
  });
  let data2 = await getCurrentYear({ appraisalService }, authenticationToken);
  data1.results.currentYear = data2.results.year;
  return data1;
};

export const fetchRollCorrections = async (
  { appraisalService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalService}/appraisal/year/${year}/rollcorrections`;
  const { body } = await get(authenticationToken, url);
  return body;
};

// const getOwnerData = async ({ reportService }, authenticationToken, ownerID) => {
//   const url = `${baseUrl}/appraisal/owner/${ownerID}`;
//   const { body } = await get(authenticationToken, url);
//   return body;
// };

export const getStateCodes = async (
  { appraisalService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=State%20Code&year=${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getMarketAreas = async (
  { appraisalService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=Market%20Area&year=${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

const getCurrentYear = async ({ appraisalService }, authenticationToken) => {
  const url = `${appraisalService}/appraisal/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getPropertyData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/${payload.pid.value}/gis`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAppraisalCompanies = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/appraisalcompanies`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const generateReportLong = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/runlargereport`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const pollReportLong = async (
  { reportService },
  authenticationToken,
  { jobName },
) => {
  const url = `${reportService}/reporting/reportlargejob/${jobName}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const generateReport = async (
  { reportService },
  authenticationToken,
  { payload, fileName },
) => {
  // const url = `${baseUrl}/public/runreport`;
  // const { body } = await put(authenticationToken, url, payload);
  // return body;

  const url = `${reportService}/reporting/runreport`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${fileName}.pdf`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const generateReportPaused = async (
  { reportService },
  authenticationToken,
  { payload },
) => {
  const url = `${reportService}/reporting/runreport`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      return blobby;
    });
};

export const downloadReportLong = async (
  { reportService },
  authenticationToken,
  { s3ID, init, reportName },
) => {
  const url = `${reportService}/reporting/reportlargejob/${s3ID}/download`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'GET',
    headers,
  })
    .then((response) => response.blob())
    .then((blobby) => {
      if (init) {
        const objectUrl = window.URL.createObjectURL(blobby);

        anchor.href = objectUrl;
        anchor.download = `${reportName}.pdf`;
        anchor.click();

        window.URL.revokeObjectURL(objectUrl);
      } else {
        return blobby;
      }
    });
};
